{
  "REGISTER": {
    "TRY_WOOT": "Create an account",
    "TITLE": "Nýskráning",
    "TESTIMONIAL_HEADER": "Það þarf aðeins eitt skref framávið",
    "TESTIMONIAL_CONTENT": "You're one step away from engaging your customers, retaining them and finding new ones.",
    "TERMS_ACCEPT": "By creating an account, you agree to our <a href=\"https://chat.jarabot.com/terms\">T & C</a> and <a href=\"https://chat.jarabot.com/privacy-policy\">Privacy policy</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Skilmálar og skilyrði</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Persónuverndarstefna</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Sign up with Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Nafn fyrirtækis",
      "PLACEHOLDER": "Sláðu inn nafn fyrirtækisins þíns. Dæmi: Wayne Enterprises",
      "ERROR": "Nafn fyrirtækis er of stutt"
    },
    "FULL_NAME": {
      "LABEL": "Fullt nafn",
      "PLACEHOLDER": "Skráðu inn fullt nafn. Dæmi: Bruce Wayne",
      "ERROR": "Fullt nafn er of stutt"
    },
    "EMAIL": {
      "LABEL": "Vinnu netfang",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Vinsamlegast sláðu inn gilt vinnu netfang"
    },
    "PASSWORD": {
      "LABEL": "Lykilorð",
      "PLACEHOLDER": "Lykilorð",
      "ERROR": "Lykilorið er of stutt",
      "IS_INVALID_PASSWORD": "Lykilorð ætti að innihalda að minnsta kosti 1 hástaf, 1 lágstaf, 1 tölustaf og 1 tákn"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Staðfesta Lykilorð",
      "PLACEHOLDER": "Staðfesta Lykilorð",
      "ERROR": "Lykilorðin stemma ekki"
    },
    "API": {
      "SUCCESS_MESSAGE": "Nýskráning tókst",
      "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
    },
    "SUBMIT": "Create account",
    "HAVE_AN_ACCOUNT": "Ertu nú þegar með aðgang?"
  }
}
